import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

export const getIntegrationState = (state) =>
  state.integration;

export const getIntegrations = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['integrations', 'data']) || List();
  }
);

export const getIntegrationsLoaded = createSelector(
  [getIntegrationState],
  (rule) => rule.getIn(['integrations', 'data']) !== undefined
);

export const getLoadingIntegrations = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['integrations', 'loading']) || false;
  }
);

export const getIntegrationFields = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['fields', 'data']) || List();
  }
);

export const getLoadingIntegrationFields = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['fields', 'loading']) || false;
  }
);

export const getLogsByFrogClient = frogId => createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'requestLogs', frogId], Map());
  }
);

export const getLoadingRequestLogs =  createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'requestLogs', 'loading'], false);
  }
);


export const getLoadingFetchLogs = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'fetchLogs', 'loading'], false);
  }
);

export interface SupervisorOption {
  value: string;
  label: string;
}

/* Supervisors are frog integrations, named by their settings or a short id. */
export const getSupervisorOptions = createSelector(
  [getIntegrations],
  (integrations): SupervisorOption[] => integrations
    .filter((integration) => integration.get('type') === 'frog')
    .map((integration) => ({
      value: integration.get('id'),
      label: integration.getIn(['settings', 'name']) || integration.get('id').substring(0, 5)
    }))
    .toArray()
);
